<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#z4mp3hmf3a)">
            <path
                d="M11.99.75v5.305c0 .41-.34.75-.75.75-.409 0-.749-.34-.749-.75V2.562L5.775 7.286a.74.74 0 0 1-.53.22.74.74 0 0 1-.529-.22.756.756 0 0 1 0-1.06L9.432 1.5H5.945c-.41 0-.75-.34-.75-.75S5.526 0 5.946 0h5.296c.1 0 .19.02.29.06.18.08.33.22.409.41.04.09.06.19.06.29l-.01-.01zM9.242 7.377c0-.41-.34-.75-.75-.75-.409 0-.748.34-.748.75V10.5H1.499V4.244h3.117c.41 0 .75-.34.75-.751 0-.41-.34-.75-.75-.75H.75c-.41 0-.749.34-.749.75v7.756c0 .41.34.751.75.751h7.743c.41 0 .75-.34.75-.75V7.375z"
            />
        </g>
        <defs>
            <clipPath id="z4mp3hmf3a">
                <path d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
</template>
